/**
 * Created by agengmaulana on 5/15/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'
import {observer} from "mobx-react"
import Comment_Row from './comment_row'
import Comment_Empty_Data from './../comment_empty_data/comment_empty_data'

@observer
export default class Comment_Master_Row extends React.Component {
    render(){
        const {dataStore,isMobile} = this.props;
        const datastoresVerified = dataStore.datastoresVerified

        let renderInfo = ''
        if (dataStore.paging.total_page === 0){
            return <Comment_Empty_Data wording={dataStore.wording} wording2={dataStore.wording2} />;}
        // else if(dataStore.loadingRow == true){
        //     return <center><img src="https://cdn.detik.net.id/libs/font-newcomment/gears.svg"/></center>
        // }
        else if(dataStore.gagalload == true){
            return <Comment_Empty_Data wording="Terjadi kesalahan." wording2="Gagal memuat komentar" />
        }
        else

        return (<div className={styles.cmt_box_komen} id="zxc">
                {
                    this.props.dataStore.datastoresKomentar.map((data,index)=>{
                        if(data.id === 'iklan-1' || data.id === 'iklan-2'){
                            return (
                                <div key={data.id} dangerouslySetInnerHTML={this._createAds(data.content)}>
                                </div>
                            )
                        }else{
                            if(!dataStore.hasAdsAsync){
                                {renderInfo = this._renderInfo(index)}
                            }
                            return (
                                <div key={data.id}>
                                    {renderInfo}
                                    <Comment_Row dataStore={data} isMobile={isMobile} datFunction={dataStore}
                                                 anchorid={dataStore.anchor} anchorparent_id={dataStore.anchormaster}
                                                 datastoresVerified={datastoresVerified}/>
                                </div>
                            )
                        }
                    })
                }

            </div>
        )
    }

    _renderInfo(index) {
        var iklan = <div key="1" id="iklan" />
        var iklan2 = <div key="1" id="iklan2" />
        let info = [];
        if (index == 2 || index == 12|| index == 22 || index == 32 || index == 42) {
            info.push(
               iklan
            );
        }
        if (index == 7 ||index == 17 || index == 27 || index == 37 || index == 47 ){
            info.push(
                iklan2
            );
        }
        return info;
    }

    _createAds(p) {
            return {__html: p};
    }

    componentDidUpdate(){
        if(this.props.dataStore.hasAdsAsync) {
            this.props.dataStore.configKomentar.loadAsyncAds();
        }
    }
}



// WEBPACK FOOTER //
// ./static/src/component/comment_row/comment_master_row.js